import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { useInvalidateTimeBlockNotes } from '@/api/reservations/get-time-block-notes'
import { useInvalidateTimeBlocks } from '@/api/reservations/get-time-blocks'

import { useInvalidateTimeBlockById } from './get-time-block-by-id'

export interface UpdateTimeBlockNoteRequest {
  timeBlockId: number
  noteId: number
  title: string
  noteBody: string
}

export const updateTimeBlockNote = async ({
  timeBlockId,
  noteId,
  ...data
}: UpdateTimeBlockNoteRequest) => {
  const response = await authAPI.put(`/time-block/${timeBlockId}/notes/${noteId}`, data)
  return response.data
}

export const useUpdateTimeBlockNote = () => {
  const invalidateNotes = useInvalidateTimeBlockNotes()
  const invalidateTimeBlocks = useInvalidateTimeBlocks()
  const invalidateTimeBlock = useInvalidateTimeBlockById()

  return useMutation({
    mutationFn: updateTimeBlockNote,
    onSuccess: (_, { timeBlockId }) => {
      invalidateNotes(timeBlockId)
      invalidateTimeBlocks()
      invalidateTimeBlock(timeBlockId)
    },
  })
}
